<template>
    <div>
        <b-card> 
           <div class="instructions">
               {{$t('choose-data-type')}}
           </div>
           <div style="cursor: pointer; display: flex; justify-content: left; align-items: left;">
            <b-dropdown size="sm" variant="link" class="data-type-dropdown" toggle-class="text-decoration-none" no-caret no-flip >
                    <template slot="button-content">
                        <!-- this b-row should be set to internet explorer size -->
                        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{$t('downloadTemplate')}}
                        </button>
                    </template>
                    <b-dropdown-item
                        v-for="(dataType,index) in dataTypes"
                        :key="index"
                        @click="downloadTemplate($t(`${dataType.typeName} (${dataType.unit})`),`${dataType.typeName}`, dataType.typeId)"> 
                            {{$t(dataType.typeName)}} - {{ $t(dataType.unit) }} 
                        </b-dropdown-item>
                </b-dropdown>
            </div>
           <br/>
            <div class="instructions">
               {{$t('load-xlsx-for-data-entrance')}}
            </div>
            <b-row align-h="start" no-gutters>
                <b-col cols="1" v-if="xlsx">
                    <upload 
                    :showUpload="false" 
                    :showDownload="false" 
                    :reactive-id="reactiveId" 
                    @onremove="()=>{this.xlsx = null;}"/>
                    <div style="font-size: 12px; text-align: center">{{xlsx.filename | textToShortText}}</div>
                </b-col>
                <b-col cols="1" style="text-align: left" v-else>
                    <upload-regular 
                    @onupload="onupload" 
                    :uploadOnCloud="false"
                    :acceptQuery="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"/>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import _ from 'lodash';
import uuid from 'uuid/v4';
import Upload from '../../components/Upload';
import UploadRegular from '../../components/UploadRegular';

export default {
    name: 'LoadDataViaExcel',
    components: {UploadRegular, Upload},
    data() {
        return {
            dataTypes: [],
            reactiveId: uuid(),
            xlsx: null
        };
    },
    methods: {
        onupload(event) {
            this.xlsx = {
                filename: event.filename,
                uuid: event.fileId,
                fileUrl: event.fileUrl
            };
            return this.axios.post('/data/read-from-excel', {
                    uuid:this.xlsx.uuid,
                    locale:this.$store.state.locale
                }, {responseType: 'blob'})//, headers: { 'Accept': 'application/vnd.ms-excel' }
                    .then(response => {
                        let headerLine = response.headers['content-disposition'];
                        let filename = decodeURI(headerLine.substring(headerLine.indexOf('"') + 1, headerLine.lastIndexOf('"')));
                        this.downloadExcelBlob(response,filename);
                        return this.$Progress.finish();
                    });

            /*    
            window.open(
                `${this.apiURL}/data/read-from-excel/${this.xlsx.uuid}/${this.$store.state.locale}?token=${this.downloadToken}`
            );
            */
            
        },
        downloadTemplate(name, type, id) {
            window.open(
                `${this.apiURL}/data/excel-template/${id}/${type}/${name}/${this.$store.state.locale}?token=${this.downloadToken}`
            );
        },
        init() {
            this.$Progress.start();
            return this.axios.get('/batchEntry').then(({data}) => {
                this.dataTypes = data;
                this. dataTypes = _.sortBy(this.dataTypes, dataType => _.toLower(this.$t(dataType.typeName)));
                this.$Progress.finish();
            });
        }
    },
    created() {
        this.downloadToken = this.token.substr(7);
        this.init();
    }
};
</script>

<style lang="scss" scoped>
.instructions {
    text-align: left;
    font-weight: bold;
    padding-bottom: 10px;
}
.data-type-dropdown /deep/ .dropdown-menu {
max-height: 75vh;
overflow-y: auto;
}

</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "choose-data-type": "Örnek şablonu indirmek için veri tipini seçiniz",
            "data-type": "Veri Tipi",
            "load-xlsx-for-data-entrance": "Veri girişi için bir xlsx dosyası yükleyiniz",
            "downloadTemplate": "Excel Şablonu İndir",
            "excel-error":"x. satırda y bulundu!",
            "conflict": "tarih uyuşmazlığı",
            "code": "kod - lokasyon uyuşmazlığı",
            "missing-information": "veri eksikliği",
            "not-found": "Dosya gönderilemedi",
            "unexpected-error": "Beklenmedik bir hata oluştu"
        },
        "en": {
            "choose-data-type": "Choose data type to download sample template",
            "data-type": "Data Type",
            "load-xlsx-for-data-entrance": "Upload a file xlsx file for data entrance",
            "downloadTemplate": "Download Template Excel",
            "excel-error": "There is an y error at line x ",
            "conflict": "date conflict",
            "code": "code - location disagreement",
            "missing-information": "missing infromation",
            "not-found": "The file couldn't upload",
            "unexpected-error": "Unexpected error"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Setting/LoadDataViaExcel.vue